
import React from 'react';
import { ProfitCalculator } from '@/components/table-calculator/ProfitCalculator';
import { ParticleBackground } from '@/components/table-calculator/ParticleBackground';

const TableCalculatorPage = () => {
  return (
    <div className="min-h-screen bg-background relative">
      {/* Subtle Background */}
      <ParticleBackground />
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-3 sm:px-4 py-4 sm:py-8">
        {/* Hero Section - Mobile Optimized */}
        <div className="text-center mb-8 sm:mb-12">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 sm:mb-6 text-primary leading-tight">
            BẢNG TÍNH 1 - 3 - 6
          </h1>
          <div className="h-0.5 sm:h-1 w-20 sm:w-32 bg-primary mx-auto mb-4 sm:mb-6 rounded-full" />
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-muted-foreground max-w-4xl mx-auto leading-relaxed px-2">
            Tính toán lợi nhuận cho <span className="text-primary font-semibold">Trade Bot 365</span> và{" "}
            <span className="text-tradebrand-green font-semibold">AI Prop</span> theo công thức{" "}
            <span className="text-tradebrand-blue font-bold text-xl sm:text-2xl lg:text-3xl">1-3-6</span>
          </p>
          <div className="mt-6 sm:mt-8 text-muted-foreground text-sm sm:text-base lg:text-lg px-2">
            🚀 Phân tích chi tiết qua 4 vòng (12 tháng) với công nghệ AI tiên tiến
          </div>
        </div>

        {/* Calculator Section */}
        <div className="max-w-7xl mx-auto">
          <ProfitCalculator />
        </div>

        {/* Footer */}
        <div className="text-center mt-12 sm:mt-16 text-muted-foreground text-xs sm:text-sm px-2">
          <p>© 2024 Trade Bot 365 & AI Prop - Hệ thống tính toán lợi nhuận thông minh</p>
        </div>
      </div>
    </div>
  );
};

export default TableCalculatorPage;
